/**
 * Theme Switcher Utility
 * 
 * This utility helps switch between 3 theme options:
 * - Option 1: Purple Gradient (default)
 * - Option 2: Dark Teal/Beige
 * - Option 3: Light Pink-Purple Gradient & Reddish-Brown
 * 
 * Usage:
 * - To switch to Option 1: setThemeOption(1)
 * - To switch to Option 2: setThemeOption(2)
 * - To switch to Option 3: setThemeOption(3)
 * - To get current theme: getCurrentTheme()
 */

export const setThemeOption = (option) => {
  const body = document.body;
  
  // Remove all theme classes
  body.classList.remove('theme-option-1', 'theme-option-2', 'theme-option-3', 'theme-option-4');
  
  if (option === 1) {
    // Option 1: Purple Gradient (default, no class needed)
    // But we can add it for clarity
    body.classList.add('theme-option-1');
  } else if (option === 2) {
    // Option 2: Dark Teal & Light Beige
    body.classList.add('theme-option-2');
  } else if (option === 3) {
    // Option 3: Light Pink-Purple Gradient & Reddish-Brown
    body.classList.add('theme-option-3');
  } else if (option === 4) {
    // Option 4: Blue Theme
    body.classList.add('theme-option-4');
  }
  
  // Save to localStorage for persistence
  localStorage.setItem('customerThemeOption', option.toString());
};

export const getCurrentTheme = () => {
  if (document.body.classList.contains('theme-option-2')) {
    return 2;
  }
  if (document.body.classList.contains('theme-option-3')) {
    return 3;
  }
  if (document.body.classList.contains('theme-option-4')) {
    return 4;
  }
  return 1; // Default to Option 1
};

export const initTheme = () => {
  // Always set Option 4 as default (user confirmed this is their preferred theme)
  setThemeOption(4);
};

